import template from './advertFeatureList.html';
import controller from './advertFeatureList.controller';
import './advertFeatureList.scss';

let advertFeatureListComponent = {
  restrict: 'E',
  bindings: {
    adverts: '<',
    orderChanged: '&',
    changeState: '&'
  },
  template,
  controller
};

export default advertFeatureListComponent;
